var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.agedOut)?_c('v-progress-linear',{staticClass:"mb-1",attrs:{"height":"3","color":_vm.colour,"background-color":"grey lighten-2","value":_vm.ageRange}}):_c('v-progress-linear',{staticClass:"mb-1",attrs:{"height":"3","color":"yellow","value":0,"background-color":"transparent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }